/**
 * In-Game Hand Card Themes & Chassis Definitions
 *
 * Separate customization category ("Cards") for in-game hand cards,
 * drag-lift preview, and hover-to-inspect zoom views.
 *
 * Supported chassis styles:
 * 1. 'glass'   - Cyber Glass (Default, monolithic crystal glass chassis with arcade crystal reflection)
 * 2. 'fluted'  - Fluted (Micro-Pinstripe edition with fine vertical ribbing, unlockable via Supply Surge)
 * 3. 'holo'    - Holo (Pearlescent Liquid Crystal chassis with organic topography curves, unlockable via Supply Surge)
 * 4. 'classic' - Classic Steel (Original military gunmetal plating, unlockable via Supply Surge)
 * 5. 'artwork' - Artwork (Pure borderless canvas artwork with edge-to-edge illustration, unlockable via Supply Surge)
 */

export const CARD_THEMES = [
  {
    id: 'glass',
    name: 'Cyber Glass',
    subtitle: 'Monolithic Crystal Chassis',
    description: 'Massives monolithisches Kristallglas-Chassis mit Kanten-Fiberglow und Klarglas-Schliff für die Handkarten im Spiel.',
    isDefault: true,
    unlockedByDefault: true,
    surgeReward: false
  },
  {
    id: 'fluted',
    name: 'Fluted',
    subtitle: 'Micro-Pinstripe Crystal Chassis',
    description: 'Monolithisches Kristallglas-Chassis mit feiner Nadelstreifen-Riffelung (Mikro-Riffelglas) für die Handkarten im Spiel.',
    isDefault: false,
    unlockedByDefault: false,
    surgeReward: true
  },
  {
    id: 'holo',
    name: 'Holo',
    subtitle: 'Liquid Crystal Topography Chassis',
    description: 'Monolithisches Cyber-Glass mit irisierendem Holo-Flüssigkristall und organischen Topo-Rillen für die Handkarten im Spiel.',
    isDefault: false,
    unlockedByDefault: false,
    surgeReward: true
  },
  {
    id: 'classic',
    name: 'Classic Steel',
    subtitle: 'Original Military Plating',
    description: 'Originales militärisches Gunmetal-Chassis mit verstärkter Titan-Lünette für die Handkarten im Spiel.',
    isDefault: false,
    unlockedByDefault: false,
    surgeReward: true
  },
  {
    id: 'artwork',
    name: 'Artwork',
    subtitle: 'Pure Canvas Edition',
    description: 'Pures randloses Karten-Artwork mit maximalem Bildbereich für die Handkarten im Spiel.',
    isDefault: false,
    unlockedByDefault: false,
    surgeReward: true
  }
];

export function getCardThemeById(id) {
  return CARD_THEMES.find(t => t.id === id) || CARD_THEMES[0];
}
